import { ROUTE_NAMES_SERVICEDESK_QUEUES_LANDING } from '@atlassian/jira-common-constants/src/spa-routes.tsx';
import type { InvariantRoute } from '@atlassian/react-resource-router/src/common/types';

export const servicedeskQueuesLandingRoute: InvariantRoute = {
	name: ROUTE_NAMES_SERVICEDESK_QUEUES_LANDING,
	// Supporting optional /default for legacy backwards compatability
	path: '/jira/servicedesk/projects/:projectKey/queues/(default|custom)?',
	exact: true,
};
